<template>
    <div class="card">
        <Toolbar>
            <template #start>
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('utm_page', 'view')"
                    icon="pi pi-chart-bar"
                    severity="secondary"
                    text
                    label="UTM"
                    @click="$router.push('/utm')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('sms_page', 'view')"
                    icon="pi pi-comments"
                    severity="secondary"
                    text
                    label="Рассылки"
                    @click="$router.push('/sms')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('kinescope_page', 'view')"
                    icon="pi pi-video"
                    severity="secondary"
                    text
                    label="Kinescope"
                    @click="$router.push('/kinescope')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('jtbd_page', 'view')"
                    icon="pi pi-objects-column"
                    severity="secondary"
                    text
                    label="JTBD"
                    @click="$router.push('/jtbd')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('wisdom_base', 'view')"
                    icon="pi pi-book"
                    severity="secondary"
                    text
                    label="База мудрости"
                    @click="$router.push('/wisdom')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('agent_page', 'view')"
                    icon="pi pi-sparkles"
                    severity="secondary"
                    text
                    label="Агент"
                    @click="$router.push('/agent')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('wisdom_base', 'view')"
                    icon="pi pi-chart-bar"
                    severity="secondary"
                    text
                    label="RAG Monitor"
                    @click="$router.push('/rag-monitor')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('html_to_pdf', 'view')"
                    icon="pi pi-file-pdf"
                    severity="secondary"
                    text
                    label="HTML → PDF"
                    @click="$router.push('/tools/html-to-pdf')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('forms_leads', 'view')"
                    icon="pi pi-inbox"
                    severity="secondary"
                    text
                    label="Заявки"
                    @click="$router.push('/leads')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('deal_exports', 'view')"
                    icon="pi pi-table"
                    severity="secondary"
                    text
                    label="Выгрузки"
                    @click="$router.push('/deal-exports')"
                />
                <ButtonVue
                    v-if="userStore.user && userStore.hasPermission('sheet_exports', 'view')"
                    icon="pi pi-file-export"
                    severity="secondary"
                    text
                    label="Таблицы"
                    @click="$router.push('/sheet-exports')"
                />
            </template>

            <!--<template #center>
                <IconField>
                    <InputIcon>
                        <i class="pi pi-search" />
                    </InputIcon>
                    <InputText placeholder="Search" />
                </IconField>
            </template>-->

            <template #end>
                <ButtonVue 
                    v-if="userStore.user && (userStore.isAdmin || userStore.hasAdminAccess)"
                    icon="pi pi-cog" 
                    severity="secondary" 
                    text 
                    label="Админка" 
                    @click="$router.push('/admin')" 
                />
                <ButtonVue
                    v-if="!userStore.user"
                    icon="pi pi-sign-in"
                    severity="secondary"
                    text
                    label="Войти"
                    @click="$router.push('/login')"
                />
            </template>
        </Toolbar>
    </div>
</template>

<script>
import { useUserStore } from '@/stores/user'
import Toolbar from 'primevue/toolbar';

export default {
    components: { 
        Toolbar
    },
    computed: {
        userStore() {
            return useUserStore()
        }
    },
    data() {
        return {
            items: [
                {
                    label: 'Главная',
                    icon: 'pi pi-home'
                },
                {
                    label: 'Features',
                    icon: 'pi pi-star'
                },
                {
                    label: 'Projects',
                    icon: 'pi pi-search',
                    items: [
                        {
                            label: 'Components',
                            icon: 'pi pi-bolt'
                        },
                        {
                            label: 'Blocks',
                            icon: 'pi pi-server'
                        },
                        {
                            label: 'UI Kit',
                            icon: 'pi pi-pencil'
                        },
                        {
                            label: 'Templates',
                            icon: 'pi pi-palette',
                            items: [
                                {
                                    label: 'Apollo',
                                    icon: 'pi pi-palette'
                                },
                                {
                                    label: 'Ultima',
                                    icon: 'pi pi-palette'
                                }
                            ]
                        }
                    ]
                },
                {
                    label: 'Contact',
                    icon: 'pi pi-envelope'
                }
            ]
        };
    }
};
</script>

<style scoped>
.card {
    margin-bottom: 1rem;
}
</style>
